import styled from 'styled-components'

import { LoaderPointsMini } from 'shared/ui/LoaderPointsMini'

export const StyledEventRowMessage = styled(LoaderPointsMini)``
